import { useEffect, useState } from "react";
import { WorkCalendarConstant } from "../../core/_constant";
import { WorkCalendarService } from "../../core/_request";
import { HttpStatusCode } from "axios";
import { Loader } from "../../../../../common/components/Loader/Loader";
import dayjs from "dayjs";
import { FormProvider } from "../../../../../common/provider/form/Form.provider";
import { Form, TimePicker } from "antd";
import { SimpleInput } from "../../../../../common/components/simpleInput";
import { CustomButton } from "../../../../../common/components/CustomButton/CustomButton";

export const WorkShedule = () => {
  const { RangePicker } = TimePicker;
  const [form] = Form.useForm();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isLoadingSubmit, setIsLoadingSubmit] = useState<boolean>(false);
  const [isChanged, setIsChanged] = useState<boolean>(false);

  useEffect(() => {
    getWorkTime(WorkCalendarConstant.WORK_ID);
  }, []);

  const getWorkTime = async (id: number) => {
    try {
      setIsLoading(true);

      const res = await WorkCalendarService.getWorkShedule(id);
      if (res?.status === HttpStatusCode.Ok) {
        const formatedData = {
          ...res?.data,
          date: [dayjs(res?.data?.startTime), dayjs(res?.data?.endTime)],
        };

        form.setFieldsValue(formatedData);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmit = async (values: any) => {
    try {
      setIsLoadingSubmit(true);
      const dataToPost = {
        id: WorkCalendarConstant.WORK_ID,
        startTime: values?.date?.[0]
          ? dayjs(values?.date?.[0]).format("HH:mm")
          : null,
        endTime: values?.date?.[1]
          ? dayjs(values?.date?.[1]).format("HH:mm")
          : null,
      };

      const res = await WorkCalendarService.patchWorkShedule(dataToPost);
      if (res?.status === HttpStatusCode.Ok) {
        setIsChanged(false);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoadingSubmit(false);
    }
  };

  return (
    <div>
      <Loader isLoading={isLoading} />

      <FormProvider
        Form={Form}
        form={form}
        debug
        onFinish={(values: any) => {
          handleSubmit(values);
        }}
        onFinishFailed={(err) => {
          console.log("err", err);
        }}
      >
        <SimpleInput
          Form={Form}
          name={"date"}
          label={"Horaire"}
          placeholder={"Référence"}
          rules={[
            {
              required: true,
              message: "Le champ référence est requis.",
            },
          ]}
          customInput={
            <RangePicker
              placeholder={["Début", "Fin"]}
              format={"HH:mm"}
              needConfirm={false}
              allowClear={false}
              onChange={() => {
                setIsChanged(true);
              }}
            />
          }
        />

        <div className="mt-4">
          <CustomButton
            type="submit"
            variant="primary"
            disabled={!isChanged}
            isLoading={isLoadingSubmit}
          >
            Enregistrer
          </CustomButton>
        </div>
      </FormProvider>
    </div>
  );
};
